/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const statePropertyEnum = {
    "PENDING": "PENDING",
    "ACTIVE": "ACTIVE",
    "COMPLETED": "COMPLETED",
    "ARCHIVED": "ARCHIVED",
    "STANDBY": "STANDBY"
} as const;

export type StatePropertyEnum = (typeof statePropertyEnum)[keyof typeof statePropertyEnum];

/**
 * @description Status des annonces immobilières :\n- PENDING: En attente de mandat\n- ACTIVE: En vente/location\n- COMPLETED: Vendu/Loué\n- ARCHIVED: Archivé\n- STANDBY: Suspendu\n
*/
export type StateProperty = StatePropertyEnum;